import axios from '@axios'

export const state = {
  statistics: [],
}

export const getters = {
  allStatistics: (state) => state.statistics,
}

export const mutations = {
  GET_STATISTICS: (state, resp) => {
    if (!resp) return false
    state.statistics = resp
  },
}

export const actions = {
  async getStatistics({ commit }) {
    await axios
      .get(`/api/cars/dashboard`)
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_STATISTICS', resp.data)
        }
      })
      .catch(() => commit('GET_STATISTICS', false))
  },
}
